import { Record } from 'immutable';
import DeliveraMenuEntity from './DeliveraEntity';
import { TranslationInterface } from './interface';

export interface DeliveraCategoryInterface {
    id: string
    title: TranslationInterface
    subtitle: TranslationInterface
    entities: DeliveraMenuEntity[]
}

const defaultDeliveraCategoryProps: DeliveraCategoryInterface = {
    id: '',
    title: {
        translations: {
            'fr': '',
            'en': ''
        }
    },
    subtitle: {
        translations: {
            'fr': '',
            'en': ''
        }
    },
    entities: []
}

export default class DeliveraCategory extends Record(defaultDeliveraCategoryProps) {

    constructor(props: any) {
        super(DeliveraCategory.reveiveProps(props));
    }

    private static reveiveProps(props: any): any {
        let data = Object.assign({}, props);
        data['entities'] = ((props['entities'] ?? []) as any[]).map((e) => new DeliveraMenuEntity(e));

        return data;
    }
}